<template>
  <layout titlePage="Domínio personalizado">
    <div class="verify-domain-availability">
      <div class="columns columns--full is-gapless is-vcentered">
        <div class="column is-two-fifths">
          <base-header-page class="is-gapless c-base-header-page--full">
            <base-icon
              width="300px"
              height="100px"
              name="dominio-personalizado"
            />
          </base-header-page>
        </div>
        <div class="column">
          <div
            class="verify-domain-availability-content container has-text-centered"
          >
            <p class="margin-bottom">
              <b>{{ pageTitle }}</b>
            </p>
            <domain-availability v-if="canCheckAvailability" />
            <domain-configured
              v-else-if="hasDomainConfigured"
              :domain="domain"
            />
            <domain-solicitation-status
              v-else-if="!hasDomainConfigured && !canCheckAvailability"
              :solicitation="solicitation"
            />
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import loadingViewMixin from '@/mixins/loadingViewMixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  mixins: [loadingViewMixin],

  components: {
    layout: () => import('@/layouts/Default.vue'),
    BaseHeaderPage: () => import('@/components/BaseHeaderPage.vue'),
    DomainConfigured: () => import('@/components/Domain/DomainConfigured.vue'),
    DomainAvailability: () =>
      import('@/components/Domain/DomainAvailability.vue'),
    DomainSolicitationStatus: () =>
      import('@/components/Domain/DomainSolicitationStatus.vue'),
  },

  metaInfo: {
    title: 'Disponibilidade de Domínio',
  },

  computed: {
    solicitation() {
      return this.$store.state.domain.solicitation
    },

    domain() {
      return this.$store.state.domain.domain
    },

    ...mapGetters({
      hasDomainConfigured: 'domain/hasDomainConfigured',
      canCheckAvailability: 'domain/canCheckAvailability',
    }),

    pageTitle() {
      const doesntSolicited =
        'Escolha um endereço personalizado para o seu site'
      const solicited = 'Acompanhe a sua solicitação de domínio personalizado'
      return this.solicitation ? solicited : doesntSolicited
    },
  },

  mounted() {
    this.fetchDomainInitialState()
  },

  methods: {
    ...mapActions({
      fetchDomainInitialState: 'domain/fetchDomainInitialState',
    }),
  },
}
</script>

<style lang="scss">
.verify-domain-availability {
  &-content {
    max-width: 400px;
    padding: 32px 16px;
    @media (min-width: $tablet) {
      padding: 60px 16px;
    }
  }

  // reset
  .margin-bottom {
    margin-bottom: 32px;
  }
  .c-base-header-page__content > .svg-icon {
    height: 85px;
  }

  @media (min-width: $tablet) {
    .c-base-header-page__content {
      padding-right: 42px;
      text-align: right;
      & > .svg-icon {
        width: 280px;
        height: 230px;
      }
    }
  }
}
</style>
